import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { fetchAuthSession } from "aws-amplify/auth";

export default function ReportDownloader() {
  const { viewerName } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const run = async () => {
      try {
        const session = await fetchAuthSession();
        const token = session.tokens?.idToken?.toString();

        if (!token) {
          alert("Not signed in.");
          return;
        }

        // XXX this URL does not have a matching API endpoint (needs to go on REST API config).
        const res = await fetch(
          `https://api.infauxtech.com/rest/v1/reports/${encodeURIComponent(viewerName)}`,
          {
            method: "GET",
            headers: {
              Authorization: token,
            }
          }
        );

        // Let browser auto-follow redirect
        if (res.redirected) {
          window.location.href = res.url;

          // ✅ Auto-redirect after short delay (to prevent idle tab)
          setTimeout(() => {
            navigate("/main");
          }, 3000); // 3-second delay
          return;
        }

        // If it's a real error (not 200)
        if (!res.ok) {
          const text = await res.text();
          try {
            const error = JSON.parse(text);
            alert(`Error ${res.status}: ${error.message}`);
          } catch {
            alert(`Error ${res.status}: ${text || 'Unknown error'}`);
          }
        }
        // Redirect back to main after showing the alert
        navigate("/main");

      } catch (e) {
        console.error("Download error:", e);
        alert("Failed to download report. Please sign in again.");
      }
    };

    run();
  }, [viewerName, navigate]);

  return (
    <div className="p-6">
      <h2 className="text-lg font-semibold">Preparing your report…</h2>
      <p className="text-gray-600">{viewerName}</p>
    </div>
  );
}
